import { post } from "../core/request";
import * as event from "../core/event";

/**
 * 最大行政区划码长度
 */
const MAX_AREA_CODE_LENGTH = 18;

/**
 * 行政区划数据
 */
let AREA_DATA = [];

/**
 * 行政区划映射数据 KEY = CODE
 */
let AREA_MAP_DATA = {};

/**
 * 行政区划树数据
 */
let AREA_TREE_DATA = null;

/**
 * 行政区划树数据映射
 */
let AREA_TREE_DATA_MAP = {};

/**
 * 初始化行政区划
 */
export function initArea() {
  return new Promise((resolve, reject) => {
    if (AREA_DATA.length) {
      // 命中缓存
      resolve(AREA_DATA);
      return;
    }
    // 注册 Hook 函数
    let initHook = false;
    if (typeof initArea._hook === "undefined") {
      initHook = true;
      initArea._hook = [];
    }
    const _hook = initArea._hook;
    _hook.push({ resolve, reject });
    if (!initHook) {
      return;
    }
    // 获取数据
    getArea().then(res => {
      handleGetAreaRes(res);
      // 回调 Hook 函数
      while (_hook.length) {
        _hook.pop().resolve(AREA_DATA);
      }
    }).catch(res => {
      // 回调 Hook 函数
      while (_hook.length) {
        _hook.pop().reject();
      }
    });
  });
}

function getArea(data) {
  return post({
    url: "/api/ums/sysArea/getArea",
    data,
  });
}

function handleGetAreaRes(res) {
  const { data = [] } = res
  AREA_DATA = [
    {
      "fullCode": 0,
      "code": "00",
      "name": "中国",
      "fullName": "中国",
      "pId": null,
      "id": "0",
      "sort": 11,
      "category": 0
    },
    ...data
  ];
  AREA_DATA.forEach(item => {
    AREA_MAP_DATA[item.fullCode] = item;
  });
  AREA_TREE_DATA = buildTree(AREA_DATA, { id: "0" });
}

function buildTree(areaList, pArea) {
  const areas = areaList.filter(v => pArea.id === v.pId);
  return areas.map(area => {
    const item = {
      "name": area.name,
      "code": area.code,
      "fullCode": area.fullCode,
      "fullName": area.fullName,
    };
    if (5 === area.category) {
      item["children"] = [];
    } else {
      item["children"] = buildTree(areaList, area);
    }
    AREA_TREE_DATA_MAP[item["fullCode"]] = item;
    return item;
  });
}

/**
 * 获取区域树
 * @param param 参数
 */
export function getAreaTree(param) {
  param = param || {};
  return new Promise((resolve, reject) => {
    initArea().then(() => {
      let tree = AREA_TREE_DATA;
      if (param.code) {
        // 获取指定子树
        let code = getFullAreaCode(param.code);
        if (AREA_TREE_DATA_MAP[code]) {
          tree = [AREA_TREE_DATA_MAP[code]];
        }
      }
      resolve(tree);
    }).catch(res => {
      reject();
    });
  });
}

/**
 * 获取完整名称
 * @param code 区域码
 */
export function getFullName(code) {
  return new Promise((resolve, reject) => {
    initArea().then(() => {
      code = getFullAreaCode(code);
      resolve(AREA_MAP_DATA[code] ? AREA_MAP_DATA[code].fullName : "");
    }).catch(res => {
      reject();
    });
  });
}

/**
 * 获取最大区域码
 * @param code 区域码
 */
export function getMaxAreaCode(code) {
  code = code + "";
  for (let i = code.length; i < MAX_AREA_CODE_LENGTH; i++) {
    code += "9";
  }
  return Number(code);
}

/**
 * 获取最小区域码
 * @param code 区域码
 */
export function getMinAreaCode(code) {
  code = code + "";
  for (let i = code.length; i < MAX_AREA_CODE_LENGTH; i++) {
    code += "0";
  }
  return Number(code);
}

/**
 * 获取完整区域码
 * @param code 区域码
 */
export function getFullAreaCode(code) {
  return getMinAreaCode(code);
}

/**
 * 获取名称
 * @param code 区域码
 */
export function getName(code) {
  code = getFullAreaCode(code);
  return AREA_MAP_DATA[code] ? AREA_MAP_DATA[code].name : "";
}

const CONFIG = [
  { level: 1, simple: 2, complete: 2, label: "省", name: "province" },      // 省、自治区、直辖市
  { level: 2, simple: 2, complete: 4, label: "市", name: "city" },          // 市(地)
  { level: 3, simple: 2, complete: 6, label: "区", name: "county" },        // 县(市、区)
  { level: 4, simple: 3, complete: 9, label: "街道", name: "street" },      // 街道(乡、镇)
  { level: 5, simple: 3, complete: 12, label: "社区", name: "community" },  // 社区（村居委会）
  { level: 6, simple: 2, complete: 15, label: "网格", name: "team" }        // 基础网格
];

/**
 * 获取配置
 * @param name 区域名称
 */
export function getConfig() {
  return CONFIG;
}

/**
 * 根据名称获取配置
 * @param name 区域名称
 */
export function getConfigByName(name) {
  if (name) {
    for (let i = 0; i < CONFIG.length; ++i) {
      if (name === CONFIG[i].name) {
        return CONFIG[i];
      }
    }
  }
  return null;
}

// /**
//  * 根据名称获取常量
//  * @param name 区域名称
//  */
// export function getConfigByName(name) {
//   var val = getConfigByName(name);
//   return null === val ? null : JSON.parse(JSON.stringify(val));
// };

// /**
//  * 获取所属级的区域位
//  * @param code 区域码
//  */
// export function getLevelBit(item, code) {
//   if (!code || !item || (item.complete > code.length)) {
//     return null;
//   }
//   return code.substring(item.complete - item.simple, item.complete);
// }

// /**
//  * 根据名称获取区域级别码
//  * @param name 区域名称
//  * @param code 区域编码
//  */
// function getLevelBitByName(name, code) {
//   return getLevelBit(getConfigByName(name), code);
// }

// 注册登录事件
event.login.on(() => { initArea(); });
